import { createApp } from 'vue'
import PhoneInput from '../common/components/PhoneInput'

window.epb = window.epb || {}
  
// Inquiry form.
const mediaPostsForm = document.getElementById('media-posts-inquiry-form')
if (mediaPostsForm) {

  // Disable the submit button on form submit.
  mediaPostsForm.addEventListener('submit', function() {
    mediaPostsForm.querySelector('button[type="submit"]').disabled = true
  })

  // Vue.js
  createApp({
    components: {
      'phone-input': PhoneInput,
    },
    data() {
      return {
        name: window.epb.name || '',
        profession: window.epb.profession || '',
        email: window.epb.email || '',
        phone: window.epb.phone || '',
        company: window.epb.company || '',
        comments: window.epb.comments || '',
      }
    },
    computed: {
      requirementsMet() {
        return (
          this.name &&
          this.profession &&
          this.email &&
          this.phone &&
          this.company &&
          this.comments
        )
      },
      charsRemaining() {
        return 200 - this.comments.length
      }
    }
  })
  .mount('#media-posts-inquiry-form')
}
